import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container-xl">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3>kinolor</h3>
                        <p>Лучший источник информации о фильмах и сериалах</p>
                    </div>
                    <div className="footer-section">
                        <h4>Навигация</h4>
                        <Link to="/">Главная</Link>
                        <Link to="/genres">Жанры</Link>
                    </div>
                    <div className="footer-section">
                        <h4>Информация</h4>
                        <p>Данные предоставлены</p>
                        <a href="https://www.themoviedb.org/" target="_blank" rel="noopener noreferrer">
                            The Movie Database (TMDB)
                        </a>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} kinolor. Все права защищены.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

